import inViewport from 'vue-in-viewport-mixin'
import { mapGetters } from 'vuex'

export default {
  mixins: [inViewport],
  props: {
    inViewportOnce: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      inViewportTriggered: false,
      isLocalGraphDataLoaded: false,
      localGraphData: null,
      isExpertiseLoaded: false,
      localExpertiseData: null,
      hasErrorGraphData: false,
      hasErrorExpertiseData: false
    }
  },
  watch: {
    'inViewport.now': {
      handler (visible) {
        if (visible) {
          this.inViewportTriggered = true
          this.fetchComparisonData(this.comparison)
        }
      }
    },
    'comparison' (newValue) {
      // If block has been in viewport, we need to load data for the other comparisonData 'manually'
      if (this.inViewportTriggered) {
        this.fetchComparisonData(newValue)
      }
    }
  },
  computed: {
    ...mapGetters({
      comparison: 'search/comparison'
    })
  },
  methods: {
    fetchComparisonData (type) {
      if (type === 'graph') {
        if (this.isLocalGraphDataLoaded) return

        this.$events.$on(`search:send:scoped_data:${this.index}:${this.data.slug}`, data => {
          this.localGraphData = data
          this.isLocalGraphDataLoaded = true
          this.hasErrorGraphData = false
          this.$events.$off(`search:send:scoped_data:${this.index}:${this.data.slug}`)
          this.$events.$off(`search:error:scoped_data:${this.index}:${this.data.slug}`)
        })
        this.$events.$on(`search:error:scoped_data:${this.index}:${this.data.slug}`, () => {
          this.hasErrorGraphData = true
          this.isLocalGraphDataLoaded = true
          this.$events.$off(`search:send:scoped_data:${this.index}:${this.data.slug}`)
          this.$events.$off(`search:error:scoped_data:${this.index}:${this.data.slug}`)
        })
        this.$events.$emit('search:fetch:scoped_data', this.data.slug_values, this.index)
      } else {
        if (this.isExpertiseLoaded) return

        this.$events.$on(`search:send:scoped_expertise_data:${this.index}:${this.data.slug}`, data => {
          this.localExpertiseData = data
          this.isExpertiseLoaded = true
          this.graphDataError = false
          this.$events.$off(`search:send:scoped_expertise_data:${this.index}:${this.data.slug}`)
          this.$events.$off(`search:error:scoped_expertise_data:${this.index}:${this.data.slug}`)
        })
        this.$events.$on(`search:error:scoped_expertise_data:${this.index}:${this.data.slug}`, () => {
          this.hasErrorExpertiseData = true
          this.isLocalGraphDataLoaded = true
          this.$events.$off(`search:send:scoped_expertise_data:${this.index}:${this.data.slug}`)
          this.$events.$off(`search:error:scoped_expertise_data:${this.index}:${this.data.slug}`)
        })

        this.$events.$emit('search:fetch:scoped_expertise_data', this.data.slug_values, this.index)
      }
    }
  },
  beforeDestroy () {
    this.$events.$off(`search:send:scoped_data:${this.index}:${this.data.slug}`)
    this.$events.$off(`search:send:scoped_expertise_data:${this.index}:${this.data.slug}`)
    this.$events.$off(`search:error:scoped_data:${this.index}:${this.data.slug}`)
    this.$events.$off(`search:error:scoped_expertise_data:${this.index}:${this.data.slug}`)
  }
}
